import { Component, Input, Output, EventEmitter, ViewChildren, QueryList, ElementRef } from '@angular/core';

@Component({
  selector: 'app-e-otp-input',
  templateUrl: './e-otp-input.component.html',
  styleUrls: ['./e-otp-input.component.css']
})
export class EOtpInputComponent {
  @Input() length: number = 6;
  @Output() otpChange = new EventEmitter<string>();

  otpArray: string[] = new Array(6).fill('');
  @ViewChildren('otpInput') inputs!: QueryList<ElementRef>;

  onInput(event: any, index: number) {
    const value = event.target.value;
    this.otpArray[index] = value;
    if (value && index < this.length - 1) {
      this.inputs.toArray()[index + 1].nativeElement.focus();
    }
    this.emitOtp();
  }

  onKeyDown(event: KeyboardEvent, index: number) {
    if (event.key === 'Backspace' && !this.otpArray[index] && index > 0) {
      this.inputs.toArray()[index - 1].nativeElement.focus();
    }
  }

  emitOtp() {
    this.otpChange.emit(this.otpArray.join(''));
  }
}



// WEBPACK FOOTER //
// /app/src/app/components/e-otp-input/e-otp-input.component.ts